export default function(gantt) {
	delete gantt.addTaskLayer;
	delete gantt.addLinkLayer;
};